import { BigNum, PRICE_PRECISION_EXP } from '@drift-labs/sdk';
import { PricingData } from './types';

const DEFAULT_VALUE = BigNum.zero(PRICE_PRECISION_EXP);

export const pricingDataToOracleBigNum = (
	pricingData: PricingData | undefined
): BigNum => {
	if (!pricingData) return DEFAULT_VALUE;
	return BigNum.fromPrint(
		pricingData.oraclePrice.toString(),
		PRICE_PRECISION_EXP
	);
};
